import logo from "../assets/logo.png";
import tickLight from "../assets/tick-light.png";
import loginLandscape from "../assets/login-landscape.png";
import loginPortrait from "../assets/login-portrait.png";
import mapLandscape from "../assets/map-landscape.png";
import mapPortrait from "../assets/map-portrait.png";
import notifLandscape from "../assets/notif-landscape.png";
import notifPortrait from "../assets/notif-portrait.png";
import background from "../assets/background.png";
import diego from "../assets/diego.jpeg";
import ali from "../assets/ali.jpeg";
import tudor from "../assets/tudor.jpeg";
import ricky from "../assets/ricky.jpeg";
import daniel from "../assets/daniel.jfif";

const images = {
  logo,
  tickLight,
  loginLandscape,
  loginPortrait,
  mapLandscape,
  mapPortrait,
  notifLandscape,
  notifPortrait,
  background,
  diego,
  ali,
  tudor,
  ricky,
  daniel,
};

export default images;
